export default __webpack_public_path__ + "static/generator_symbol_w.901da3b58727d0699e1b18294f9c2b98.svg";